import { trials } from "../trials";

export const TITLE_MAPPING: Record<string, string> = {
  subject: "Subject ID",
  participant_id: "Participant ID",
  site: "Site ID",
  birth_date: "DOB",
  indication: "Indication Name",
  study_arm_label: "Study Arm",
  timepoint: "Visit Type",
  date: "Administration Date",
  time: "Administration Time",
  administration_method_change_date_raw: "Administration Method Change Date",
  weight_kg: "Weight (kg)",
  ip_change: "IP Change",
  dose_mg_vivo: "Actual Dose Administered",
  reason_altered: "IP Change Reason",
  ip_change_reason_other_specify: "IP Change Reason Other Specify",
  ip_change_date_derived: "IP Change Date",
  total_vol_admin_yn: "Dose Administered Per Protocol",
  dose_mg_edc: "Dose To Be Administered",
  dose_to_be_administered_unit: "Dose To Be Administered Unit",
  reas_vol_not_admin: "Entire Dose Not Administered Reason",
  dose_altered_ae: "IP Change Reason AE",
  expected_volume_ml_edc: "Volume To Be Administered",
  volume_unit_source_value: "Volume Unit",
  actual_volume_ml_edc: "Volume Administered",
  num_syringes: "Quantity Prepared Method",
  was_dose_administered: "Administered YN",
  expected_volume_ml_vivo: "Expected Volume",
  expected_volume_unit_derived: "Expected Volume Unit",
  actual_volume_ml_vivo: "Actual Volume",
  admin_loc: "Administration Location",
};

export const DOSE_UNITS = "mg/kg";

export const DEFAULT_HIDDEN_COLUMNS = new Set([
  "subject",
  "participant_id",
  "site",
  "days",
]);

export const DEFAULT_HIDDEN_COLUMNS_SINGLE_VIEW = new Set([
  "subject",
  "participant_id",
  "sex",
  "birth_date",
  "indication",
  "country",
  "participant_id",
  "study_status",
  "site",
  "days",
]);

export const DEFAULT_COLUMN_ORDER_SI_SINGLE_VIEW = [
  "timepoint",
  "activity_status",
  "date",
  "time",
  "weight_kg", // Weight (kg)
  "dose_mg_vivo", // Expected Dose (mg) Vivo
  "dose_mg_edc", // Expected Dose (mg) EDC
  "expected_volume_ml_vivo", // Expected Volume (mL) Vivo
  "expected_volume_ml_edc", // Expected Volume (mL) EDC
  "actual_volume_ml_vivo", // Actual Volume (mL) Vivo
  "actual_volume_ml_edc", // Actual Volume (mL) EDC
  "dose_per_weight", // Administered Dose (mg/kg) Vivo
  "total_vol_admin_yn", // Entire Vol (mL) Administered (Yes/No)
  "reas_vol_not_admin", // Reason Entire Vol Not Administered
  "dose_altered_ae", // Associated adverse event
  "reason_altered", // Reason for dose alteration
  "admin_loc", // Administration Location
  "num_syringes", // Syringes
];

export const BB_COLUMN_ORDER_SI_SINGLE_VIEW = [
  "timepoint",
  "activity_status",
  "date",
  "time",
  "weight_kg",
  "dose_mg_vivo",
  "dose_mg_edc",
  "expected_volume_ml_vivo",
  "expected_volume_ml_edc",
  "actual_volume_ml_vivo",
  "actual_volume_ml_edc",
  "dose_per_weight",
  "total_vol_admin_yn",
  "reason_altered",
  "reas_vol_not_admin",
  "admin_loc",
  "num_syringes",
];

export const getTrialColumns = (trialId: string): string[] => {
  if (trialId === trials.bridgebio.PROPEL) {
    return BB_COLUMN_ORDER_SI_SINGLE_VIEW;
  }
  return DEFAULT_COLUMN_ORDER_SI_SINGLE_VIEW;
};

export const TRACKER_DEFAULT_HIDDEN_COLUMNS = new Set([
  "country",
  "participant_id",
  "days",
]);

export const COLUMN_WIDTHS: Record<string, number> = {
  activity_status: 150,
  timepoint: 130,
  date: 160,
  time: 160,
  site: 110,
  subject: 120,
  study_status: 140,
  weight_kg: 130,
  num_syringes: 130,
  actual_dose_mg_kg_vivo: 260,
  expected_volume_ml_edc: 240,
  expected_volume_ml_vivo: 240,
  total_dosage: 145,
  study_arm_label: 130,
  admin_loc: 160,
  dose_mg_vivo: 150,
  dose_mg_edc: 150,
  DEFAULT: 130,
};

export const FIXED_COLUMNS = new Set([
  "subject",
  "participant_id",
  "site",
  "timepoint",
  "activity_status",
  "study_arm_label",
]);

export const TRACKER_FIXED_COLUMNS = new Set([
  "subject",
  "participant_id",
  "site",
  "timepoint",
  "study_status",
  "total_dosage",
  "study_arm_label",
]);

export const SEARCHABLE_COLUMNS = new Set([
  "subject",
  "site",
  "participant_id",
  "timepoint",
]);

export const COLUMNS_WITH_LINK = new Set(["subject"]);

export const STATUS_COLUMNS = new Set(["study_status"]);

export const NO_TIMEPOINT_COLUMNS = new Set([
  "subject",
  "participant_id",
  "site",
  "country",
  "study_status",
  "study_arm_label",
]);

export const TOTAL_DOSAGE_COLUMNS = ["total_dosage"];

export const TOTAL_MAX_EXPECTED_DOSE = 23;
export const TOTAL_MIN_EXPECTED_DOSE = 21;
